const UA = window.navigator.userAgent;

export const isFF = UA.indexOf('Firefox') > -1;
